export default __webpack_public_path__ + "static/media/g.93459d8f.svg";